import React, { ReactNode } from 'react';

import { Label, Wrapper } from './Badge.styled';

interface IBadge {
  text: string;
  color: string;
  backgroundColor: string;
  borderColor?: string;
  width?: string;
  clockIcon?: ReactNode;
  height?: string;
  fontFamily?: string;
  fontSize?: string;
  leftIcon?: ReactNode;
}

export const Badge = ({
  text,
  color,
  backgroundColor,
  borderColor,
  width,
  clockIcon,
  height,
  fontFamily,
  fontSize,
  leftIcon,
}: IBadge) => {
  return (
    <Wrapper
      backgroundColor={backgroundColor}
      borderColor={borderColor}
      width={width}
      height={height}
    >
      {leftIcon}
      <Label color={color} fontFamily={fontFamily} fontSize={fontSize}>
        {text}
      </Label>
      {clockIcon}
    </Wrapper>
  );
};
